module.exports = __webpack_public_path__ + "img/discover.2adf67ca.svg";